import CuttingName from "./CuttingName";
import CuttingLink from "./CuttingLink";


import LocationName from "../../../../location/components/location/LocationDetail/LocationName";
import LocationLink from "../../../../location/components/location/LocationDetail/LocationLink";

import ProviderName from "../../../../timber/components/provider/ProviderDetail/ProviderName";
import ProviderLink from "../../../../timber/components/provider/ProviderDetail/ProviderLink";

import ContractorName from "../../../../timber/components/contractor/ContractorDetail/ContractorName";
import ContractorLink from "../../../../timber/components/contractor/ContractorDetail/ContractorLink";

import ForestOwnerName from "../../../../timber/components/forestOwner/ForestOwnerDetail/ForestOwnerName";
import ForestOwnerLink from "../../../../timber/components/forestOwner/ForestOwnerDetail/ForestOwnerLink";
import { toStringDisplay as toStringCuttingState } from "../../../types/models/CuttingState.d";
import { toStringDisplay as toStringShipmentState } from "../../../types/models/ShipmentState.d";
import { toStringDisplay as toStringShipmentType } from "../../../types/models/ShipmentType.d";
import { toStringDisplay as toStringUserType } from "../../../types/models/UserType.d";
import { toStringDisplay as toStringCordwoodMeasurementType } from "../../../types/models/CordwoodMeasurementType.d";

import {NavLink, useParams} from "react-router";
import Refresh from "@mui/icons-material/Refresh";
import Clear from "@mui/icons-material/Clear";
import Grid from '@mui/material/Grid';
import {displayDateTime, displayDate, displayTime} from "../../../../utils/formatDate";
import {percentageFormat, fixedFormat, currencyFormat} from "../../../../utils/numberFormat";
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import CheckBoxOutlineBlankOutlinedIcon from '@mui/icons-material/CheckBoxOutlineBlankOutlined';
import {Stack, Typography, Card, CardHeader, CardContent, IconButton} from "@mui/material";
import React from "react";
import { Trans } from "@lingui/react/macro";
import { t } from "@lingui/core/macro";

const CuttingDetail = ({ data = {}, label = '', showTitle = true, refetch = undefined, scoped = false }) => {
    
    data = data || {}
        
    return (
        <Stack direction="column" spacing={3}>
            {showTitle &&
                <Stack direction="row" justifyContent="left" spacing={1}>
                    <Typography
                            sx={ { flex: '1 1 100%' } }
                            variant="h6"
                            component="div"
                            data-testid="Cutting-detail-title"
                    >
                        { label || t`Cutting` }: <CuttingName id={data?.id}/>
                    </Typography>
                    <Stack direction="row" justifyContent="right" spacing={1}>
                        {refetch &&
                            <IconButton size="medium" variant="contained" data-testid="Cutting-refresh-button"
                                        color="inherit"
                                        onClick={refetch}>
                                <Refresh />
                            </IconButton>
                        }
                        {!scoped &&
                            <IconButton size="medium" variant="contained" data-testid="Cutting-cancel-button"
                                        color="inherit"
                                        component={NavLink}
                                        to=".."
                                        relative="path"
                                        viewTransition={true}
                            >
                                <Clear />
                            </IconButton>
                        }
                    </Stack>
                </Stack>
            }
            <Grid container rowSpacing={2} columnSpacing={ { xs: 1, sm: 2, md: 3 } }>
                
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="name-label"><Trans>Name</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="name-value" >{ data.name || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="state-label"><Trans>State</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="state-value" >{ toStringCuttingState(data.state) || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="startAt-label"><Trans>Start At</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="startAt-value" >{displayDateTime(data.startAt) || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="endAt-label"><Trans>End At</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="endAt-value" >{displayDateTime(data.endAt) || '-' }</Grid>
                    
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="workOrder-label"><Trans>Work Order</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="workOrder-value" >{ data.workOrder || '-' }</Grid>
                    
                    
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="locationId-label"><Trans>Location</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="locationId-value" >{ data.locationId ? (<LocationLink id={ data.locationId }/>) : '-' }</Grid>
                    
                    
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="providerId-label"><Trans>Provider</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="providerId-value" >{ data.providerId ? (<ProviderLink id={ data.providerId }/>) : '-' }</Grid>
                    
                    
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="contractorId-label"><Trans>Contractor</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="contractorId-value" >{ data.contractorId ? (<ContractorLink id={ data.contractorId }/>) : '-' }</Grid>
                    
                    
                    <Grid size={ {xs: 4} } textAlign="left" data-testid="forestOwnerId-label"><Trans>Forest Owner</Trans>:</Grid>
                    <Grid size={ {xs: 8} } textAlign="left" data-testid="forestOwnerId-value" >{ data.forestOwnerId ? (<ForestOwnerLink id={ data.forestOwnerId }/>) : '-' }</Grid>
                    
            </Grid>
        </Stack>
    )
}

export default CuttingDetail;
